// Splash
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    console.log("cargado");
    var overlay = document.getElementById('main-overlay');
    overlay.classList.add('cargado');
    // overlay.addEventListener("transitionend", function() {
      // overlay.parentNode.removeChild(overlay);
    // }, false);
    // overlay.style.opacity = 0;
  }, false);
}())


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/scss/app.scss'


Vue.config.productionTip = false

Vue.config.devtools = process.env.NODE_ENV === 'development';

Vue.prototype.$globalEvent = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
